export default __webpack_public_path__ + "ed3f1c9f7704b4b7cf5705813dccfc88.svg";